import React from "react";
import { Modal } from "react-bootstrap";
import Success from "../../assets/images/success.svg";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

function CourseCreateSuccessfullModal({ show, onClose }) {
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);

  let message = "";
  if (auth.role === "Instructor") {
    message = "Your course has been created and sent for admin approval. You will be notified once approved.";
  } else if (auth.role === "Admin") {
    message = "Your course has been created successfully.";
  } else {
    message = "Your course has been submitted!";
  }

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      size="md"
      className="success-modal"
    >
      <Modal.Header closeButton className="px-35 py-20">
        <Modal.Title className="fw-semibold ah-heading-05 text-black">
          Course Added
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-45 pt-32 pb-20 text-center">
        <div className="mb-16 text-center">
          <img src={Success} alt="Success" className="img-fluid mx-auto" />
        </div>
        <p className="text-gray-600 ah-text-base fw-semibold mb-19">
          {message}
        </p>
        <button type="button" className="btn btn-primary w-100" onClick={()=> navigate("/instructor-courses")}>Continue</button>
      </Modal.Body>
    </Modal>
  );
}

export default CourseCreateSuccessfullModal;
